<template>
    <div class="hg-prompt">
        <h4 class="header">
            <span v-i18n="'HG_QUESTION'" />
        </h4>
        <div class="body">
            <label v-i18n="question" />
            <div class="extra" v-html="response"></div>
        </div>

        <button @click="onDeny();$modal.hideAll()" v-i18n="'NO'" class="btn-abort hg-input"/>
        &nbsp;
        <button @click="onConfirm();$modal.hideAll()" v-i18n="'YES'" class="btn-primary hg-input"/>
    </div>
</template>
<script>
export default {
    props: {
        question: {type: String},
        response: {},
        onConfirm: {type: Function},
        onDeny: {type: Function},
    }
}
</script>
<style scoped>
.hg-prompt{padding:5px; background:#FFFFFF;padding-bottom:10px;}
/* .hg-prompt img{ height:120px; margin-bottom:20px; text-align:center;display:inline-block;} */
.hg-prompt .header{ margin:0; padding: 5px; }
.hg-prompt .body{
    padding: 15px;
}
</style>